export default "__VITE_ASSET__C$Mq1bzv__"